module.exports = __webpack_public_path__ + "img/shop-window.f6c90b22.svg";